import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Import marker images from leaflet package
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Fix default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function isInCanadaOrUSA(lat, lon) {
  if (typeof lat !== "number" || typeof lon !== "number") return false;

  // Bounding box for USA + Canada (approx)
  const north = 83.0;
  const south = 24.5;
  const west = -168.0;
  const east = -52.0;

  return lat >= south && lat <= north && lon >= west && lon <= east;
}

const DeviceLocation = ({ latitude, longitude }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  let finalLat = latitude;
  let finalLon = longitude;

  if (!isInCanadaOrUSA(latitude, longitude)) {
    // if device has 0 0 coordination we show them in that area
    finalLon = -97.8462684;
    finalLat = 32.7406863;
  }

  useEffect(() => {
    // Prevent re-initialization if map already exists
    if (mapInstanceRef.current) {
      mapInstanceRef.current.remove();
    }

    const map = L.map(mapRef.current, {
      minZoom: 2,
      maxZoom: 19,
    }).setView([finalLat, finalLon], 17.5);

    // 🌍 Satellite layer
    L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
      }
    ).addTo(map);

    // 🏷️ Labels overlay
    L.tileLayer(
      "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
      }
    ).addTo(map);

    // 📍 Marker
    L.marker([finalLat, finalLon]).addTo(map);

    mapInstanceRef.current = map;

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [finalLat, finalLon]);

  return (
    <div
      ref={mapRef}
      className="w-full h-full min-h-full rounded-lg overflow-hidden"
      style={{ minHeight: "300px" }} // fallback minimum height
    />
  );
};

export default DeviceLocation;
